import * as THREE from 'three';
import { getWeaponById, pickRandomWeaponId, rarityColor } from './weaponRuntime.js';

export function spawnAmmoPickup({
  scene,
  dropHoverMeta,
  ammoPickups,
  x,
  z,
  amount = 6,
}) {
  const geo = new THREE.BoxGeometry(0.45, 0.28, 0.28);
  const mat = new THREE.MeshStandardMaterial({
    color: 0xffcf66,
    emissive: 0xffa533,
    emissiveIntensity: 0.5,
    roughness: 0.45,
    metalness: 0.2,
  });
  const mesh = new THREE.Mesh(geo, mat);
  mesh.position.set(x, 0.28, z);
  mesh.castShadow = true;
  mesh.userData.dropType = 'ammo';
  scene.add(mesh);
  dropHoverMeta.set(mesh, { name: 'AMMO', meta: 'AMMO PACK', hint: 'Move to collect' });
  ammoPickups.push({ mesh, x, z, amount, t: Math.random() * Math.PI * 2, radius: 0.5 });
}

export function spawnWeaponPickup({
  scene,
  dropHoverMeta,
  weaponPickups,
  rng,
  x,
  z,
  weaponId,
}) {
  const weapon = getWeaponById(weaponId);
  if (!weapon) return;
  const color = parseInt(rarityColor(weapon.rarity).slice(1), 16);
  const geo = new THREE.OctahedronGeometry(0.38, 0);
  const mat = new THREE.MeshStandardMaterial({
    color,
    emissive: color,
    emissiveIntensity: 0.45,
    roughness: 0.32,
    metalness: 0.18,
  });
  const mesh = new THREE.Mesh(geo, mat);
  mesh.position.set(x, 0.42, z);
  mesh.castShadow = true;
  mesh.userData.dropType = 'weapon';
  scene.add(mesh);
  dropHoverMeta.set(mesh, {
    name: weapon.name.toUpperCase(),
    meta: `${weapon.rarity.toUpperCase()} ${weapon.category.toUpperCase()}`,
    hint: 'E/F to equip',
    rarity: weapon.rarity,
  });
  weaponPickups.push({
    mesh,
    x,
    z,
    radius: 0.68,
    t: rng() * Math.PI * 2,
    weaponId: weapon.id,
    weaponName: weapon.name,
    rarity: weapon.rarity,
  });
}

export function spawnRoomWeaponPickup(game, roomNum) {
  if (game.runMode !== 'run') return;
  const anchors = (game.room?.enemySpawns || []).slice();
  if (anchors.length === 0) return;
  const idx = Math.floor(game.rng() * anchors.length);
  const anchor = anchors[idx];
  const allowLegendary = roomNum >= 4;
  const weaponId = pickRandomWeaponId(game.rng, { allowLegendary });
  if (!weaponId) return;
  game._spawnWeaponPickup(anchor.x, anchor.z, weaponId);
}
